// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FooterBodyBlock__container___W6Gd6 {
    overflow: auto;
}

[data-show-mode='full'] .FooterBodyBlock__container___W6Gd6 {
    height: 100%;
}

[data-show-mode='none'] .FooterBodyBlock__container___W6Gd6 {
    height: 0;
}

[data-show-mode='half'] .FooterBodyBlock__container___W6Gd6 {
    height: var(--footer-body-height);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/Footer/FooterBlocks/FooterBodyBlock.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iCAAiC;AACrC","sourcesContent":[".container {\n    overflow: auto;\n}\n\n[data-show-mode='full'] .container {\n    height: 100%;\n}\n\n[data-show-mode='none'] .container {\n    height: 0;\n}\n\n[data-show-mode='half'] .container {\n    height: var(--footer-body-height);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FooterBodyBlock__container___W6Gd6`
};
export default ___CSS_LOADER_EXPORT___;
